const RelationalModel = require('../extensions/relational-model.js');
const RelationalCollection = require('../extensions/relational-collection.js');
const parameters = require('./parameters.js');

const Studio = RelationalModel.extend({
  // nothing
});

const StudioCollection = RelationalCollection.extend({
  model: Studio,
  url() {
    return `${parameters.get('api_base_url')}/${parameters.get('client_token')}/studios`;
  }
});

module.exports = new StudioCollection();



// WEBPACK FOOTER //
// ./src/data/studios.js